/**
 * DIEUKYDIEU.TV - AUDIO TRACKS PLAYLIST (PART 1: TRACKS 1-3)
 */

export const tracksPart1 = [
    {
        id: "track-1",
        title: "Chúng tôi đến vì bạn",
        title_i18n: {
            vi: "Chúng tôi đến vì bạn",
            en: "We Come For You",
            "zh-TW": "我們為你而來",
            "zh-CN": "我们为你而来"
        },
        artist: "Zhengjian Art • dieukydieu.tv",
        artist_i18n: {
            vi: "Zhengjian Art • dieukydieu.tv",
            en: "Zhengjian Art • dieukydieu.tv",
            "zh-TW": "正見藝術 • dieukydieu.tv",
            "zh-CN": "正见艺术 • dieukydieu.tv"
        },
        img: "https://picsum.photos/400/400?random=201",
        src: "https://www.zhengjian.org/sites/default/files/files/2026/09/wmwnel-jx_0.mp3",
        duration: "3:45",
        lyrics: `Vượt ngàn trùng non xanh và biển rộng,
Chúng tôi đến nơi đây vì bạn.
Mang theo ánh sáng chân lý diệu kỳ,
Khơi dậy thiện niệm trong sâu thẳm tâm can.

Chân - Thiện - Nhẫn chiếu rọi thế gian,
Xua tan màn đêm u tối mịt mùng.
Dẫu phong ba bão táp ngút trời,
Lòng kiên định vững vàng niềm tin son sắt.

Hỡi người hữu duyên ơi, xin hãy lắng nghe,
Tiếng gọi của sinh mệnh từ chốn vĩnh hằng.
Tìm về bản ngã nguyên sơ thuần khiết,
Đón chào ánh bình minh rạng rỡ huy hoàng.`,
        syncedLyrics: [
            { time: 10, text: "Vượt ngàn trùng non xanh và biển rộng," },
            { time: 22, text: "Chúng tôi đến nơi đây vì bạn." },
            { time: 34, text: "Mang theo ánh sáng chân lý diệu kỳ," },
            { time: 46, text: "Khơi dậy thiện niệm trong sâu thẳm tâm can." },
            { time: 66, text: "Chân - Thiện - Nhẫn chiếu rọi thế gian," },
            { time: 78, text: "Xua tan màn đêm u tối mịt mùng." },
            { time: 90, text: "Dẫu phong ba bão táp ngút trời," },
            { time: 104, text: "Lòng kiên định vững vàng niềm tin son sắt." },
            { time: 124, text: "Hỡi người hữu duyên ơi, xin hãy lắng nghe," },
            { time: 138, text: "Tiếng gọi của sinh mệnh từ chốn vĩnh hằng." },
            { time: 152, text: "Tìm về bản ngã nguyên sơ thuần khiết," },
            { time: 168, text: "Đón chào ánh bình minh rạng rỡ huy hoàng." }
        ]
    },
    {
        id: "track-2",
        title: "Trở về chốn Thiên đình",
        title_i18n: {
            vi: "Trở về chốn Thiên đình",
            en: "Returning to Heaven",
            "zh-TW": "重返天庭",
            "zh-CN": "重返天庭"
        },
        artist: "Âm Nhạc Đại Pháp • dieukydieu.tv",
        artist_i18n: {
            vi: "Âm Nhạc Đại Pháp • dieukydieu.tv",
            en: "Dafa Music • dieukydieu.tv",
            "zh-TW": "大法音樂 • dieukydieu.tv",
            "zh-CN": "大法音乐 • dieukydieu.tv"
        },
        img: "https://picsum.photos/400/400?random=202",
        src: "https://www.zhengjian.org/sites/default/files/files/2026/07/chongfantianting-jx.mp3",
        duration: "4:12",
        lyrics: `Nguyện ước ngàn năm ghi khắc tim người,
Hạ thế phong trần qua bao kiếp luân hồi.
Tìm kiếm chân lý soi đường dẫn lối,
Nay đã ngộ ra con đường phản bổn quy chân.

Cõi hồng trần danh lợi chỉ là hư ảo,
Tâm thanh tịnh tựa đóa sen ngát hương.
Theo bước Đại Đạo thênh thang rạng rỡ,
Cùng nhau trở về cố hương chốn Thiên đình.`,
        syncedLyrics: [
            { time: 12, text: "Nguyện ước ngàn năm ghi khắc tim người," },
            { time: 26, text: "Hạ thế phong trần qua bao kiếp luân hồi." },
            { time: 42, text: "Tìm kiếm chân lý soi đường dẫn lối," },
            { time: 58, text: "Nay đã ngộ ra con đường phản bổn quy chân." },
            { time: 82, text: "Cõi hồng trần danh lợi chỉ là hư ảo," },
            { time: 98, text: "Tâm thanh tịnh tựa đóa sen ngát hương." },
            { time: 116, text: "Theo bước Đại Đạo thênh thang rạng rỡ," },
            { time: 135, text: "Cùng nhau trở về cố hương chốn Thiên đình." }
        ]
    },
    {
        id: "track-3",
        title: "Đắc Độ (Salvation)",
        title_i18n: {
            vi: "Đắc Độ (Salvation)",
            en: "Salvation (De Du)",
            "zh-TW": "得度",
            "zh-CN": "得度"
        },
        artist: "Nhạc Khúc Tịnh Tâm • dieukydieu.tv",
        artist_i18n: {
            vi: "Nhạc Khúc Tịnh Tâm • dieukydieu.tv",
            en: "Peaceful Meditation • dieukydieu.tv",
            "zh-TW": "靜心樂曲 • dieukydieu.tv",
            "zh-CN": "静心乐曲 • dieukydieu.tv"
        },
        img: "https://picsum.photos/400/400?random=203",
        src: "https://www.zhengjian.org/sites/default/files/files/2026/09/wmwnel-jx_0.mp3",
        duration: "3:58",
        lyrics: `Lạc bước nhân gian muôn dặm trường,
Tìm đâu bến đỗ chốn yêu thương.
Đại Pháp hồng truyền ban phúc lành,
Tâm sáng soi đường thoát bi thương.

Nhân duyên vạn kiếp nay tao ngộ,
Trân quý từng giây chớ lỡ làng.
Chân - Thiện - Nhẫn khắc sâu đáy dạ,
Đắc độ trở về cõi bình yên.`,
        syncedLyrics: [
            { time: 14, text: "Lạc bước nhân gian muôn dặm trường," },
            { time: 28, text: "Tìm đâu bến đỗ chốn yêu thương." },
            { time: 44, text: "Đại Pháp hồng truyền ban phúc lành," },
            { time: 60, text: "Tâm sáng soi đường thoát bi thương." },
            { time: 86, text: "Nhân duyên vạn kiếp nay tao ngộ," },
            { time: 102, text: "Trân quý từng giây chớ lỡ làng." },
            { time: 120, text: "Chân - Thiện - Nhẫn khắc sâu đáy dạ," },
            { time: 138, text: "Đắc độ trở về cõi bình yên." }
        ]
    }
];
